import PropTypes from "prop-types";
import React, { ReactElement, useState } from "react";
import { connect } from "react-redux";
import Loader from "../common/Loader";
import SignUp from "../signUp/signup";
import LoginForm from "./loginForm";
import LoginIntro from "./loginIntro";

// const loginBgStyle = {
//   // width: '100%',
//   backgroundImage: `url(${LoginBg.src})`,
//   // height: "100vh",
//   backgroundPosition: 'center',
//   backgroundSize: 'cover',
//   backgroundRepeat: 'no-repeat',
//   position: 'relative',
//   left: '-2px',
// }

const Login = ({ data }: any): ReactElement => {
  const [displayForm, setDisplayForm] = useState("login");

  return (
    <React.Fragment>
      {data?.loading ? (
        <Loader />
      ) : (
        <div className="login-container">
          <div className="container-fluid no-padding">
            <div className="row g-0">
              <div
                className="col-lg-6 col-md-6 login-banner"
                style={{
                  width: "100%",
                  // backgroundImage: `url(${LoginBg})`,
                  height: "100vh",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "stretch",
                  position: "relative",
                  left: "-2px",
                }}
                // {...data}
              >
                {/* <div className="login-banner-overlay"></div> */}
                <LoginIntro />
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="admin-login-wrapper">
                  {/* <h2 className="d-title">
                    <span>
                      {`LET'S`} GOT <br />
                      YOU{' '}
                    </span>
                    STARTED
                  </h2> */}

                  {displayForm === "login" ? <LoginForm /> : <SignUp />}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

Login.propTypes = {
  data: PropTypes.object,
};

const mapStateTopProps = (state: { authReducer: any }) => {
  return { data: state.authReducer };
};

export default connect(mapStateTopProps, null)(Login);
